import React from 'react';
import clsx from 'clsx';
import { nearestAvailability } from '../../utils/availabilities';
import { useTranslation } from '@/src/i18n';
import { dayjsWithTimezone } from '@/src/utils';
import { analyticsEvent } from '@/src/analytic_tag_manager';

type Props = {
  consultationType?: string;
  closestAvailabilities: {
    closestPhysicalAvailability: any;
    closestTeleconsultationAvailability: any;
    availabilityCount: number;
  } | null;
  navigate: Function;
  timezone: string;
  title?: string;
};

const ClosestAvailability = ({
  consultationType,
  closestAvailabilities,
  navigate,
  timezone,
  title,
}: Props) => {
  const { t } = useTranslation();
  const dayjsTZ = dayjsWithTimezone(timezone);
  if (!closestAvailabilities) {
    return <div />;
  }

  const closestDate = nearestAvailability(
    closestAvailabilities,
    consultationType,
    timezone,
  );

  const onClickNavigate = () => {
    if (closestDate) {
      analyticsEvent({
        category: 'Booking',
        action: 'ClickFirstAvailabilities',
      });
      navigate(dayjsTZ(closestDate));
    }
  };

  return (
    <div className="calendar-info-availability">
      <span
        className={clsx('info-availability', closestDate && 'clickable')}
        onClick={onClickNavigate}
      >
        {closestDate ? (
          <>
            {t(title ?? 'closest_availability')}
            <br />
            <span className="date percy-hidden">
              {dayjsTZ(closestDate).format('dddd DD MMMM')}
            </span>
          </>
        ) : (
          t('closest_availability_none_short')
        )}
      </span>
    </div>
  );
};
export default ClosestAvailability;
